import apiService from "../common/commonApi";

export const inquiryData = {};

inquiryData.list = async (param) => {    
    return apiService.Get('inquirydata-list', param);
}
